import { z } from 'zod';

export enum ViewMode {
  DEFAULT = 'default',
  PROJECT_MANAGEMENT = 'project_management',
}

export const viewModeSchema = z.nativeEnum(ViewMode);
